<template>
  <div>
    <div class="top_slider col-xl-12">
      <div class="swiper-container ">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in slider_data" :key="item.id">
            <a :href='item.exhibit_domain == undefined ? item.url : "https://" + item.exhibit_domain.domain' target="_blank">
              <picture>
                <source media="(max-width: 768px)"
                  :srcset="item.fb_image_url == undefined ? item.image2_url : item.fb_image_url"
                  :alt="item.short == undefined ? item.title : item.short" />
                <img :src='item.banner == undefined ? item.image_url : item.banner[1].image'
                  :alt="item.short == undefined ? item.title : item.short" />
              </picture>
            </a>
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <!-- <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div> -->
      </div>

    </div>
    <div v-show="slider_data.length == 0" style="margin:40px auto;font-size:21px;text-align: center;">
      <img src="../../assets/loading.gif">
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css';
import Swiper from 'swiper';
import { setTimeout } from 'timers';
import { constants } from 'crypto';

export default {
  props: ['exhibit_data'],
  data() {
    return {
      slider_img: [],//總管理後台 exhibit_data=>csm後台
      slider_data: [],//最後顯示資料
      datasrc: "",
    }
  },
  computed: {
  },
  mounted() {
    var vm = this
    var slider_api = process.env.VUE_APP_API + 'tlweb/banner?position=1'
    this.axios.get(slider_api)
      .then(function (response) {
        vm.slider_img = response.data.data.data
        vm.exhibit_merge()
      })
      .catch(function (error) {
        console.log(error);
      });
    new Swiper('.top_slider .swiper-container', {
      spaceBetween: 30,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      lazy: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      observer: true,//修改swiper自己或子元素时，自动初始化swiper
      // observeParents:true,//修改swiper的父元素时，自动初始化swiper
    })
  },
  methods: {
    exhibit_merge() {
      if (this.exhibit_data.length > 0) {
        var slider = this.slider_img
        for (var x = 0; x < this.slider_img.length; x++) {
          for (var y = 0; y < this.exhibit_data.length; y++) {
            if (this.slider_img[x].title.trim() == this.exhibit_data[y].short.trim()) {
              this.exhibit_data.splice(y, 1);
            }
          }
        }
        this.slider_data = this.slider_img.concat(this.exhibit_data);
        //有特殊需求從總管理後台上傳的跟CMS後台合併後重新排序
        //merge開始
        function merge(left, right) {
          var result = [];
          while (left.length > 0 && right.length > 0) {
            if (left[0].end_date < right[0].end_date) {
              result.push(left.shift());
            } else {
              result.push(right.shift());
            }
          }
          return result.concat(left, right);
        }
        function mergeSort(arr) {
          if (arr.length <= 1) return arr;
          var middle = Math.floor(arr.length / 2);
          var left = arr.slice(0, middle);
          var right = arr.slice(middle);
          return merge(mergeSort(left), mergeSort(right));
        }
        this.slider_data = mergeSort(this.slider_data)
        //merge結束

        //  this.slider_data.sort(function (a, b) {
        //    console.log(a.short)
        //    console.log(new Date(a.end_date))
        //    console.log(b.short)
        //    console.log(new Date(b.end_date))
        //    console.log(new Date(a.end_date) - new Date(b.end_date))
        //    console.log('---test---')
        //     return new Date(a.end_date) - new Date(b.end_date)
        //   });
        //  console.log("slider_data", this.slider_data)
      } else {
        setTimeout(() => {
          this.exhibit_merge()
        }, 100);
      }
    },
  },
}
</script>

<style lang="sass">
  .top_slider
    padding: 0
    width: 100%
    .swiper-container
      width: 100%
      max-width: 100%
    .swiper-slide
      width: 100%
      // max-height: 550px
      height: auto;
      margin: 0
      a
        width: 100%
        height: 100%
    img
      width: 100%
      height: 100%
      object-fit: cover;

  @media (min-width: 769px)
    .top_slider .mobile_slider
      display: none

  @media (max-width: 768px)
    .top_slider .pc_slider
      display: none
</style>
